import React, { Component } from 'react';

export default class SketchyArrow extends Component {
  static propTypes = {};

  render() {
    return (
      <svg {...this.props} width="232px" height="175px" viewBox="-1 -3 232 175">
        <path d="M71.9841787,2.6436038 C113.315812,-3.73005772 133.737615,-0.516757023 141.877528,76.4178253 C143.931142,95.8276121 142.534794,115.760083 142.863428,135.431212" stroke="#DD7373" strokeWidth="5" strokeLinecap="round" fill="none"></path>
        <path d="M126.682347,118.626914 C153.643355,149.697798 135.81449,132.963155 162.02563,115.000968" stroke="#DD7373" strokeWidth="4" fill="none"></path>
        <path d="M0.682920821,169.715771 C35.7675204,169.715771 70.877625,170.355287 105.93672,169.715771 C144.403027,169.014103 258.98529,168.990129 221.112986,165.694885 C154.38726,159.889125 84.9288077,166.640679 17.7913908,162.046304 C-31.7058791,158.659088 117.8174,161.326573 167.796408,162.046304 C204.364669,162.572912 28.5284255,152.293455 58.0485772,162.626035 C76.7384595,169.167828 337.588435,158.185943 62.653848,165.216209 C49.5327504,165.551724 10.6842818,166.138445 23.5201697,167.481946 C114.764828,177.032295 389.342986,145.946227 16.4899012,164.115252 C-13.8276182,165.592616 77.0798535,167.414532 107.505181,168.24251 C127.688246,168.79176 147.958202,167.796221 168.152371,168.24251 C169.085778,168.263138 168.152371,169.13604 168.152371,169.582805" stroke="#DD7373" strokeWidth="3" fill="none"></path>
      </svg>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SketchyArrow/SketchyArrow.js
 **/